<template>
<v-card outlined hover v-on:width="width" max-width="800">
  <div>
    <v-card-actions class="d-flex justify-end bg-aqua-teal">
        <v-btn icon @click="selectionHandler()" v-if="!noActions"> 
            <v-icon v-if="!isSelected"> mdi-plus-circle-outline </v-icon>
            <v-icon v-else color="#ff6d44"> mdi-close-circle-outline</v-icon>
        </v-btn>
        <v-btn icon @click="favoriteHandler()" v-if="!noActions">
            <v-icon v-if="!isFavorited"> mdi-heart </v-icon>
            <v-icon v-else color="#ff6d44"> mdi-heart </v-icon>
        </v-btn>
        <v-btn v-if="canAddTaskNotes && !noActions" icon @click="dialog = !dialog">
            <v-icon> mdi-note-plus </v-icon>
        </v-btn>
        <v-btn :href="item.link" target="_blank" rel="noopener noreferrer" icon> 
            <v-icon>mdi-arrow-right-bold-circle</v-icon> 
        </v-btn>
    </v-card-actions>
  </div>
  <v-card-title class="mont-font mont-bold text-left text-wrap">
        {{ item.item }}
    </v-card-title>
    <v-card-text class="mont-font text-left">
            {{ item.itemDescription }}
    </v-card-text>
  <div class="d-flex justify-center mb-4" v-if="isYouTubeLink(item.link)">
    <iframe
            id="video"
            height="250px"
            :src="convertToEmbedLink(item.link)"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
    ></iframe>
  </div>
  <v-card-subtitle class="bg-aqua-teal" v-if="showStatus && Object.hasOwn(item, 'status')">{{ item.status }}</v-card-subtitle>
</v-card>
<task-notes-form 
:dialog="dialog" 
@close-dialog="dialog = !dialog"
@save-notes="saveNotes"
:title="item.item"
:text="getTaskNotes"
/>
</template>

<script>
import TaskNotesForm from './TaskNotesForm.vue';
export default {
    name: "ItemCard",
    components: {
        TaskNotesForm
    },
    props: {
        item: {
            type: Object, 
            required: true
        },
        inCart: Boolean,
        noActions: {
            type: Boolean, 
            default: false
        },
        showStatus: {
            type: Boolean, 
            default: false
        },
        canAddTaskNotes: {
            type: Boolean, 
            default: false
        }
    },
    emits: ['addSelection', 'removeSelection',
            'addFavorite', 'removeFavorite'
    ],
    data() {
        return {
            width: Number,
            selected: false, 
            isFavorited: false,
            dialog: false,
            taskNotes: "",
        }
    },
    methods: {
        isYouTubeLink(url) {
            const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)(\/.*)?$/;
            return youtubeRegex.test(url);
        },
        convertToEmbedLink(watchLink) {
            if (watchLink.includes('youtube.com/watch?v=')) {
                return watchLink.replace('watch?v=', 'embed/');
            }
            console.error('Invalid YouTube watch link');
            return null;
        },
        dummyFunction(){
            alert('Button clicked')
        },
        favoriteHandler(){
            // let idIfDefined = (this.item) ? this.item.
            this.isFavorited = !this.isFavorited;
        },
        saveNotes(notes){
            if (this.item){
                // eslint-disable-next-line
                this.item['taskNotes'] = notes;
                this.taskNotes = notes;  
            }
            this.dialog = false; 
        },
        // Method to propogate information to parent
        selectionHandler(){  
            let propIfDefined = this.item;
            if (!this.selected && propIfDefined){
                this.selected = !this.selected;
                this.$emit('addSelection', propIfDefined);
            } else if (propIfDefined) {  // Remove item if deselected 
                this.selected = !this.selected;
                this.$emit('removeSelection', propIfDefined);
            }
        }
    },
    mounted() {
        if (this.item) {
            /* If proposition applied, set selected boolean to match 
            initial inCart value.*/
            if (this.inCart) {
                this.selected = this.inCart;
            }

            /* If proposition applied, make sure item has 
            a taskNotes field.*/
            if (this.canAddTaskNotes) {
                if (!Object.hasOwn(this.item, 'taskNotes')){
                    // eslint-disable-next-line
                    this.item['taskNotes'] = null; 
                } else {
                    this.taskNotes = this.item['taskNotes'];
                }
            }
        }
    },
    computed: {
        isSelected(){
            return this.selected || this.inCart; 
        },
        videoWidth(){
            return `${this.width * 2}`
        },
        getLink(){
            return this.item.link; 
        },
        getTaskNotes(){
            if (this.taskNotes === null){
                return "";
            }
            return this.taskNotes;
        }        
    },
}
</script>

<style>
.bg-aqua-teal {
    background-color: #08b6aa;
}

/* Adjust width of video as screen size changes. */
#video {  
    width: 70%;
}
</style>